import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import { useDispatch, useSelector } from "react-redux";
import { getAssetLists } from '../../actions/assetListAction';
import { Link } from "react-router-dom";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { exportToExcelUsingRef } from '../../utils/excelExporter';
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { UrlPath } from "../../../config/routeConfig";
import download from './images/download.svg';
import { TopBar } from '../../shared/topBar/TopBar';
import { LicenseManager } from "ag-grid-enterprise";
import './AssetList.css';
import { setActiveMenu } from "../../actions/CommonAction";
import { sbaAxios } from "../../utils/sbaAxios";
import { deleteAssetbyIdAPI, getCustomSettings } from "../../../config/apiConfig";
import  {SBGrid } from "../../UiComponents/SBAAGgrid";
import { component } from "../../../config/componentConfig";
import { Modal } from "react-bootstrap";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
LicenseManager.setLicenseKey("Using_this_AG_Grid_Enterprise_key_( AG-044405 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Seven Bridges Advisors LLC )_is_granted_a_( Single Application )_Developer_License_for_the_application_( SB Platform )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( SB Platform )_need_to_be_licensed___( SB Platform )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 27 June 2024 )____[v2]_MTcxOTQ0MjgwMDAwMA==a0e8aadff8e5a26bb0ba15e56958c594");

export const AssetList = () => {
  const dispatch = useDispatch();
  const Gstate = useSelector(state => state) || {};
  const isEditable = Gstate.authorizationData.isEditable;
  const assetListDataItems = Gstate.assetList.assetList || [];
  const history = useNavigate();
  const [gridApi, setGridApi] = useState();
  const [colDef, setColDef] = useState();
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [selectedAsset,setSelectedAsset]=useState(null);
  const [deleteModal,setDeleteModal]=useState(false);
  const assetGridRef = useRef();
  // const gridApi = useRef(null);
  const [loading, setLoading] = useState(true);
  const EditButtonRenderer = (props) => {
    const handleEditClick = () => {
      props.onEditButtonClick(props);
    };
    return (
      <button onClick={handleEditClick} style={{ border: "none", height: "0px" }}><i className="fas fa-edit" style={{ color: "black" }}></i></button>
    );
  };
  const datevaluformaterapply = (params) => {
    if (!params.value) {
        return ""; 
    }
    return moment(params.value).format("MM/DD/YYYY");
}

  const onEditButtonClick = (AssetId) => {
    history(`${UrlPath.AssetEdit}${AssetId}`);
  };
  const onViewButtonClick = (AssetId) => {
    history(`${UrlPath.AssetDetails}${AssetId}`);

  };
  const getCustomSetting = async () => {
    try {
      const response = await sbaAxios({ url: `${getCustomSettings}${component.AssetList}` });
      if (response) {
        
        const apiColDef = JSON.parse(response.CustomSettingsValue);
        const apiFilters = JSON.parse(response.CustomFilterValue);

        const isClientSpecificExists = apiColDef.some(item => item.colId === "IsClientSpecific");

      if (!isClientSpecificExists) {
        apiColDef.push({
          colId: "IsClientSpecific",
          field: "IsClientSpecific",
          filter: false,
          headerName: "Client Specific",
          cellRenderer: 'agCheckboxCellRenderer'
        });
      }
        const formattedDef = apiColDef.map(item => {
          if (item.colId === "Action") {
            return { ...item, "field": item.colId, cellRenderer: ActionsRenderer, filter: false }
          }
          else if (item.colId === "AssetName") {
              return { ...item, "field": item.colId, cellRenderer: HyperlinkRenderer, filter: 'agTextColumnFilter', "headerName":"Asset Name" }
          }
          else if(item.colId === "ThreeYrTWR" || item.colId === "OneYrTWR" || item.colId === "YtdTWR" || item.colId === "FiveYrTWR" || item.colId === "ITDTWR" )  {
            return { ...item, "field": item.colId, filter: 'agTextColumnFilter', cellRenderer: decimalpointsFormatter }
          }
          else if (item.colId === "ValuationDate") {
              return { ...item, "field": item.colId, cellRenderer: datevaluformaterapply, filter: false, "headerName": "Valuation Date" }
          }
          else if (item.colId === "BloombergId") {
            return { ...item, "field": item.colId, filter: 'agTextColumnFilter', "headerName": "Ticker" }
          }
          else if (item.colId === "AbbrName") {
            return { ...item, "field": item.colId, filter: 'agTextColumnFilter', "headerName": "Abbreviation" }
          }
          else if (item.colId === "IsClientSpecific") {
            return { 
              ...item, 
              "field": item.colId,  // Keep the field name consistent
              filter: false, 
              "headerName": "Client Specific",
              cellRenderer: 'agCheckboxCellRenderer'
            };
          }
          else 
          return {...item, cellRenderer: null , "field": item.colId, filter: 'agTextColumnFilter'}        
      });
        return { columns: formattedDef, filters: apiFilters };
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  useEffect(() => {
    dispatch(getAssetLists());
    document.title = `Asset List`;
      fetchGridData();
  }, []);
  useEffect(() => {
    fetchGridData();
  }, [assetListDataItems]);
  const fetchGridData = async () => {
    try {
      const customSettings = await getCustomSetting();
      setColDef(customSettings.columns);
      setAppliedFilter(customSettings.filters);
    } catch (error) {
      console.error("Error fetching custom settings:", error);
    }
  };
  useEffect(() => {
    assetListDataItems && setLoading(false);
  }, [assetListDataItems]);
  const HyperlinkRenderer = (props) => {
    const handleLinkClick = (event) => {
      event.stopPropagation();
      dispatch(setActiveMenu(2));
    };
    const Asset = props.data.AssetId;
    return (
      <Link to={`${UrlPath.AssetDetails}${Asset}`} onClick={handleLinkClick}>
        {props.value}
      </Link>
    );
  };
  const ActionsRenderer = (props) => {
    const assetId = props.data.AssetId;
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
    useEffect(() => { setIsEdit(isEditable) }, [isEditable])
    const handleEditClick = () => {
      if(isEdit)
      onEditButtonClick(assetId);
    };
    const handleDeleteClick = () => {
      if(isEdit)
      {
        setSelectedAsset(props.data);
        setDeleteModal(true);
      }
    }
    return (
      <div className="actions-cell">
        <i className="fas fa-edit" style={{ color: isEdit ? "#47A547" :"grey", margin: "0 8px", cursor: "pointer" }} onClick={handleEditClick}></i>
        {/* <i className="fa fa-eye" style={{ color: "#3C5F7A", margin: "0 8px", cursor: "pointer" }} onClick={handleViewClick}></i> */}
        <i className="fa fa-trash" style={{ color: isEdit ? "red" :"grey", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
      </div>)

  };
  const navigateToAssetAdd = () => {
    history(`${UrlPath.AssetAdd}`, { state: { ActiveTab: "AssetList", currentAssetId: 0 } })
  };
  const decimalpointsFormatter = (params) => {
    if (params.value !== null) {
      const formattedValue = parseFloat(params.value * 10).toFixed(2);
      const className = formattedValue < 0 ? "text-end text-negative" : "text-end";
      return <div className={className}>
        {formattedValue}
      </div>
    }

  };
  const gridValueFormatter = (params) => {
    return params.value;
  };
  const Level = [{ BreadCrumb: "Asset", Routes: `${UrlPath.Asset}` }];
  return (
    <>
      {loading ? <><LoadingScreen /></> : <>
        <TopBar label={"Asset"} />
        <div id="assetList" className="mainContentData">
          <BreadCrumbs Levels={Level} />
          <div className="container-fluid">
            <div>
              <div className="d-flex justify-content-end gap-2">
                <button type="submit" className="p-sm-btn mx-1" onClick={navigateToAssetAdd} disabled={!isEditable} ><i className="fa-solid fa-plus" /> Add</button>
                <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(assetGridRef, "Asset List.xlsx") }}><img src={download} alt="Excel" />Export</button>
              </div>
              <SBGrid ref={assetGridRef} column={colDef} row={assetListDataItems} filters={appliedFilter} componentID={component.AssetList} gridStyle={{ width: '100%', height: '70vh' }}></SBGrid>
            </div>
          </div>
        </div>
      </>
      }
      <DeleteModal asset={selectedAsset} deleteModal={deleteModal} setDeleteModal={setDeleteModal}/>
      <ToastContainer />
    </>
  )
};
const DeleteModal = ({ asset, deleteModal, setDeleteModal }) => {
  const dispatch = useDispatch();
  const deleteSelectedAsset = async () => {
    const res = await deleteAssetbyID(asset.AssetId);
    if (res === 1) {
      dispatch(getAssetLists());
      SBNotify({ Msg: "Selected Asset Has Been Deleted Successfully" });
    }
    else if(res ===2 )
    SBNotify({ Msg: "Unable to Delete Asset.  The Selected Asset has Linked Items in the System", type: 'error' });
    else if (res === -1)
      SBNotify({ Msg: "Exception While Deleting the Selected Asset", type: 'error' });
    setDeleteModal(false);
  }
  return <>
    <Modal show={deleteModal}>
      <Modal.Header
        closeButton
        onClick={() => {
          setDeleteModal(false);
        }}
      >
        <Modal.Title>Do you want to delete the selected Asset?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Asset will be deleted permanently. Are you sure?</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="s-sm-btn mx-1"
          onClick={() => {
            setDeleteModal(false);
          }}
        >
          Cancel
        </button>
        <button
          className="p-sm-btn mx-1"
          onClick={() => {
            deleteSelectedAsset();
          }}
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  </>
};
const deleteAssetbyID = async (id) => {
  try {
    return sbaAxios({ url: `${deleteAssetbyIdAPI}${id},0`, })
  }
  catch (e) {
    console.log(e, "Error While deleting the Asset");
    return -1;
  }
};